import Powerup from '@FreeRider/Track/Powerups/Powerup';
import Mass from '@FreeRider/Physics/Mass';

/**
 * Checkpoint
 */
class Checkpoint extends Powerup
{
    /**
     * Collides with mass
     * @param mass
     */
    public collide(mass: Mass)
    {
        const vehicle = mass.getParent();
        const player = vehicle.player;

        const x = mass.position.x - this.x;
        const y = mass.position.y - this.y;

        const distance = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));

        if (player.hasConsumedPowerup(this) === false)
        {
            if (distance < 26 && player.isAlive && vehicle.stable)
            {
                player.setCheckpoint();
                player.addConsumedPowerup(this);
            }
        }
    }
}

export default Checkpoint;